export default "__VITE_ASSET__BYs1y80F__"